class SliderChanger {
	constructor(element) {
		this.swiperContainer = element;
		this.swiper = this.swiperContainer.swiper;
		this.tm = null;
		this.timeout = 10000;
		this.slidersType = this.getSlidersType();

		this.pauseAll();
		this.addVideosListeners();

		this.swiper.on('slideChange', (swiper) => {
			this.initSlide(swiper.activeIndex);
		});

		this.initSlide(0);
	}

	getSlidersType() {
		return window.innerWidth > 767 ? 'desktop' : 'mobile';
	}

	pauseAll() {
		this.swiperContainer.querySelectorAll('video').forEach((video) => {
			video.pause();
		});
	}

	addVideosListeners() {
		this.swiperContainer.querySelectorAll('video').forEach((video) => {
			video.addEventListener('ended', () => {
				this.nextSlide();
			});
		})
	}

	initSlide(index) {
		this.pauseAll();
		clearTimeout(this.tm);

		let video = this.swiper.slides[index].querySelector(`[data-type=${this.slidersType}] video`);
		if (video) {
			video.play();
		} else {
			this.tm = setTimeout(() => {
				this.nextSlide();
			}, this.timeout);
		}
	}

	nextSlide() {
		if (this.swiper.slides[this.swiper.activeIndex + 1]) {
			this.swiper.slideNext();
		} else {
			this.swiper.slideTo(0);
		}
	}
}

function onReady() {
	const swiperContainer = document.querySelector('#swiper-slider');

	if (!swiperContainer) {
		return;
	}

	new SliderChanger(swiperContainer);
}

document.addEventListener('DOMContentLoaded', onReady);
onTurboRender(onReady);
